import React, {Component} from 'react';
import PopAnimationImage from '../gadgets/PopAnimationImage';
import ProjectCarousel from '../components/Carousels/ProjectsCarousel';
import Button from '../gadgets/Button';
import Divider from '../gadgets/Divider';
import MapContainer from '../gadgets/MapContainer';
import './styles/LandingPage.css';

import {connect} from 'react-redux';

class LandingPage extends Component {
    render() {
        const shuffle = function (projects) {
            let p = projects.slice(0, projects.length);

            for (let i = p.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [p[i], p[j]] = [p[j], p[i]];
            }
            return p.slice(0, 6);
        };

        const projects = shuffle(this.props.projects);

        return (
            <div className={'container'}>
                <section className={'section landing section--yellow-pink header'}>
                    <div className={'grid'}>
                        <div className={'col--6 landing__content'}>
                            <div className={'content'}>
                                <div className={'content__section text--white'}>
                                    <div>
                                        <h4 className={'sub-category'}>UNIVERSITY OF SYDNEY PRESENTS</h4>
                                        <h1 className={'landing__title text--white'}>D18: 100 YEARS OF INNOVATION</h1>
                                    </div>
                                    <div>The D18 exhibition will showcase the work of students
                                        completing the Bachelor of Design Computing and the
                                        Master of Interaction Design and Electronic Arts.
                                        Both courses explore the intersection of two worlds:
                                        design and technology.
                                        <br/>
                                        <br/>
                                        The show will feature ground-breaking new ideas
                                        with emerging digital technologies and creative
                                        thinking across robotics and drones, mobile apps,
                                        3D modelling, digital systems and experiences, and
                                        wearable technology. Come along to our opening
                                        night and join us in celebrating the unwavering
                                        dedication and enormous achievements of our
                                        graduates.
                                    </div>
                                </div>
                                <div className={'content__section text--white'}>
                                    <Button href={"/v/promo"} label={'watch video'} color={'yellow-inverted'}/>
                                </div>
                            </div>
                        </div>
                        <div className={'col--6 landing__image'}>
                            <div className={'landing-image__container'}>
                                <div className={'landing-image'}
                                     style={{backgroundImage: 'url(https://res.cloudinary.com/d18gradshow/image/upload/v4/landing-page/poster-half-2.png)'}}>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={'section'}>
                    <div className={'grid'}>
                        <div className={'col--6 col--center'}>
                            <div className={'content'}>
                                <div className={'content__section'}>
                                    <h2>OUR GRADUATES</h2>
                                    <Divider color={'green'} type={'short'}/>
                                </div>
                                <div className={'content__section'}>
                                    <div>The graduating cohort from our Design Computing
                                        and MIDEA programs represent the next generation
                                        of innovators. From students to designers,
                                        our 2018 graduates are set on a path towards
                                        successful careers. This exhibition is a celebration
                                        of each student’s creative journey and the exciting
                                        opportunities that lie ahead.
                                    </div>
                                </div>
                                <div className={'content__section'}>
                                    <Button label={'view graduates'} color={'green'} href={'/graduates'}/>
                                </div>
                            </div>
                        </div>
                        <div className={'col--6'}>
                            <PopAnimationImage
                                img={"https://res.cloudinary.com/d18gradshow/image/upload/v1539611376/landing-page/gradshowdrafty_RETRO.png"}
                                colors={['blue-green', 'pink-yellow']}/>
                        </div>
                    </div>
                </section>
                <section className={'section section__carousel'}>
                    <div className={'grid'}>
                        <div className={'col--12'}>
                            <div className={'content'}>
                                <div className={'content__section'}>
                                    <h2>THEIR PROJECTS</h2>
                                    <Divider color={'pink'} type={'short'}/>
                                </div>
                                <div className={'content__section'}>
                                    <ProjectCarousel projects={projects} projectSlde={true}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={'section'}>
                    <div className={'grid'}>
                        <div className={'col--5'}>
                            <div className={'title-text'}>
                                <h2>HOW TO GET HERE</h2>
                                <Divider color={'purple'} type={'short'}/>
                            </div>
                            <h4 className={'sub-category'}>Address:</h4>
                            <div>The University of Sydney School of Architecture, Design and Planning Wilkinson
                                Building, 148 City Rd, Darlington
                            </div>
                            <br/>
                            <h4 className={'sub-category'}>Opening Hours:</h4>
                            <div>29 November : 6:30 pm - 10:00 pm</div>
                            <div>30 November : 10:00 am - 5:00 pm</div>
                            <div>01 December : 10:00 am - 5:00 pm</div>
                            <br/>
                            <a className={'link'} href="https://www.facebook.com/events/248463649351015"
                               target={'_blank'}><h4 className={'sub-category'}>RSVP now on Facebook</h4></a>
                            <br/>
                            <Button
                                href={"https://res.cloudinary.com/d18gradshow/raw/upload/v1/assets/d18-cal-event.ics"}
                                notLocal={true}
                                label={'add to calendar'} color={'purple'}/>
                        </div>
                        <div className={'col--7 google_maps'}>
                            <MapContainer/>
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

const MapStateToProps = (state) => ({
    projects: state.projects,
});

export default connect(MapStateToProps)(LandingPage);